module.exports = __webpack_public_path__ + "img/zhaoshang_qudao@2x.a346882b.png";